<template>
  <div class="login-box-wrap" v-if="showLoginBox">
    <div class="login-box">
      <div class="header">
        <div class="title">{{titleMap[loginBoxPage]}}</div>
        <div class="close" @click="close" v-if="!currRouterIsLogin">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="content" :class="{'is-register': loginBoxPage === 5}">
        <wx-qrcode-login v-if="loginBoxPage === 1" @change-page="changePage" @login-success="loginSuccess"></wx-qrcode-login>
        <account-login v-if="loginBoxPage === 2" @change-page="changePage" @login-success="loginSuccess"></account-login>
        <phone-login v-if="loginBoxPage === 3" @change-page="changePage" @login-success="loginSuccess"></phone-login>
        <forget-password v-if="loginBoxPage === 4" @change-page="changePage"></forget-password>
        <wxa-register v-if="loginBoxPage === 5"></wxa-register>
      </div>
      <div class="footer">
        <div class="left-box">
          <div class="agreement-box" v-if="[1, 2, 3, 5].indexOf(loginBoxPage) > -1">
            {{loginBoxPage === 5 ? '注册' : '登录'}}即同意 <router-link :to="{ name: 'PrivacyPolicy', params: { to: 'peer' } }" target="_blank">用户协议</router-link> 和 <router-link :to="{ name: 'PrivacyPolicy', params: { to: 'privicy' } }" target="_blank">隐私政策</router-link>
          </div>
        </div>
        <div class="right-box">
          <div class="handle-btn" v-if="[1, 2, 3].indexOf(loginBoxPage) > -1" @click="changePage(5)">免费注册<i class="icon el-icon-arrow-right"></i></div>
          <div class="handle-btn" v-if="[4, 5].indexOf(loginBoxPage) > -1" @click="backLogin">返回登录<i class="icon el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapState, mapActions, mapMutations } from 'vuex';
import {
  SAVE_MP_WATCH,
  IS_LOGIN,
  QRCODE_GET,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

// import Http from '@/libs/http';
import User from '@/libs/user';
import { LOGIN_FROM_MAP } from '@/maps/sensors-maps';
import WxQrcodeLogin from './components/wx-qrcode-login';
import AccountLogin from './components/account-login';
import PhoneLogin from './components/phone-login';
import ForgetPassword from './components/forget-password';
import WxaRegister from './components/wxa-register';


export default {
  name: 'login-box',
  components: {
    WxQrcodeLogin,
    AccountLogin,
    PhoneLogin,
    ForgetPassword,
    WxaRegister,
  },
  data() {
    return {
      page: 1,
      titleMap: {
        1: '微信安全登录',
        2: '手机号登录',
        3: '手机号登录',
        4: '密码找回',
        5: '免费注册',
      },
      prePage: 1,
    };
  },
  watch: {
    showLoginBox: {
      handler(value) {
        if (value) {
          document.body.style.overflow = 'hidden';
          document.body.style.paddingRight = '15px';
        } else {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState([
      'showLoginBox',
      'loginBoxPage', // 当前显示的页面，1：微信登录，2：账号密码, 3: 手机验证码， 4：忘记密码， 5：注册
      'loginFrom',
      'loginNotReload',
    ]),
    fromPalmyou() {
      return Boolean(this.$route.query.business_openid);
    },
    currRouterIsLogin() {
      return this.$route.matched.some(path => path.meta.needLogin);
    },
  },
  methods: {
    ...mapActions('followOA', [
      QRCODE_GET,
    ]),

    ...mapMutations('followOA', [
      SAVE_MP_WATCH,
      IS_LOGIN,
    ]),

    ...mapMutations(['SHOW_LOGIN_BOX', 'CLOSE_LOGIN_BOX', 'CHANGE_LOGIN_BOX_PAGE']),
    close() {
      this.CLOSE_LOGIN_BOX();
    },
    changePage(page) {
      // 前一次的page，用于注册页面返回使用
      this.prePage = this.loginBoxPage;
      this.CHANGE_LOGIN_BOX_PAGE(page);
    },
    backLogin() {
      this.CHANGE_LOGIN_BOX_PAGE(this.prePage);
    },
    // 埋点
    loginBuriedPoint(peer) {
      let from = this.loginFrom;
      // 如果没有来源，则取路由
      if (!from) {
        from = this.$route.fullPath.substring(this.$route.fullPath.indexOf('/') + 1, this.$route.fullPath.length);
      }
      sensorsdata.track('login', {
        login_source: LOGIN_FROM_MAP[from],
        peer_name: peer.name,
      });
      sensorsdata.login(peer.visa_peer_id);
    },
    loginSuccess(userData) {
      // 埋点
      this.loginBuriedPoint(userData);
      window.localStorage.setItem('loginErrorNum', 0);
      // 登录是如果不是金棕榈，则清除掉本地存储中的 is_palmyou（null，0，1）
      if (!this.fromPalmyou) {
        if (localStorage.getItem('is_palmyou')) {
          localStorage.removeItem('is_palmyou');
        }
      }
      User.login(userData);
      // 旧逻辑，存储到localStorage上，这样才能触发关注公众号弹窗
      this.IS_LOGIN({ isLogin: 1 });
      // 保存用户是否关注公众号的状态
      this.SAVE_MP_WATCH({ mp_watch: userData.mp_watch });
      this.close();
      if (!this.loginNotReload) {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-box-wrap{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1100;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);
  .login-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background: #fff;
    box-shadow:0px 10px 30px -10px rgba(95,102,110,0.2);
    border-radius:4px;
    color: #2F333D;
    overflow: hidden;
    .header{
      padding: 32px 24px 0 24px;
      position: relative;
      text-align: center;
      .title{
        font-size: 20px;
        font-weight: 600;
      }
      .close{
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 16px;
        cursor: pointer;
        color: #91999F;
        &:hover{
          color: #2F333D;
        }
      }
    }
    .content{
      padding: 24px 42px;
      height: 408px;
      &.is-register{
        height: 342px;
      }
    }
    .footer{
      height: 56px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 16px;
      background: #FAFBFC;
      .left-box{
        flex-grow: 1;
        .agreement-box{
          color:#91999F;
          font-size: 14px;
          a{
            color: #2F333D;
            cursor: pointer;
          }
        }
      }
      .right-box{
        flex-shrink: 0;
        .handle-btn{
          color: #599FFF;
          font-size: 16px;
          display: flex;
          align-items: center;
          cursor: pointer;
          line-height: 1;
          .icon{
            font-size: 12px;
            margin-left: 5px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/login-box.vue